<template>
  <div class="productImage">
    <img class="img-responsive" :src="imageUrl" alt="">
  </div>
</template>
<script>
export default {
  name: "GlassImage",
  props: ['imageUrl'],
  setup(props) {
    console.log(props.imageUrl)
  }
};
</script>
